$(document).ready(function(){

	if ($('[data-component="search"]').length > 0) {
		var search = new Search();
	}

	if ($('[data-component="internal-transfer-request"]').length > 0) {
		var internalTransferRequest = new InternalTransferRequest();
	}

	if ($('[data-page="mailbox-search"]').length > 0) {
		var mailboxSearch = new MailboxSearch();
	}

	if ($('[data-page="documents-notices-search"]').length > 0) {
		var documentsNoticesSearch = new DocumentsNoticesSearch();
	}

	if ($('[data-page="security-user-preferences"]').length > 0) {
		var securityUserPreferences = new SecurityUserPreferences();
	}

});
